import styles from "./SuggestionChips.module.css";

interface SuggestionChipsProps {
  title?: string;
  prompts: string[];
  onPick: (prompt: string) => void;
  disabled?: boolean;
}

export function SuggestionChips({ title, prompts, onPick, disabled }: SuggestionChipsProps) {
  return (
    <div className={styles.row}>
      {title && <span className={styles.title}>{title}</span>}
      <div className={styles.chips}>
        {prompts.map((prompt) => (
          <button
            key={prompt}
            type="button"
            className={styles.chip}
            onClick={() => !disabled && onPick(prompt)}
            disabled={disabled}
          >
            <span className={styles.arrow} aria-hidden>
              →
            </span>
            {prompt}
          </button>
        ))}
      </div>
    </div>
  );
}
